import { useIntl } from '@/intl'
import { tok } from '@sunwebgroup/ui-components'
import { Typography } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  flex-wrap: wrap;
  padding: ${tok('primitives_space_8')} ${tok('primitives_space_16')};

  ${Typography} {
    ${Typography.modVariant('body-m-bold-tight')}
    text-align: left;
  }
`

const SearchValue = styled.span`
  color: ${tok('primitives_color_primary_500')}
`

export function DestinationNoResult({ inputValue }: { inputValue: string }) {
  const intl = useIntl()
  return (
    <Wrapper>
      <Typography>
        {intl.formatMessage({ id: 'quicksearch_search_no_results_text' })}
        {' '}
        <SearchValue>{inputValue}</SearchValue>
      </Typography>
    </Wrapper>
  )
}
